import React, { useContext } from 'react';

const GiftWrapper = React.createContext();

const Child = () => {
    const value = useContext(GiftWrapper);

    return (<div>
        <p>Child</p>
        <p>{value}</p>
    </div>)
}

const Parent = () => {
    return (<div>
        <p>Parent</p>
        <Child />
    </div>)
}

const UseContext = () => {
    const candy = ".... I got candy!!!";

    return (<div>
        <GiftWrapper.Provider value={candy}>
            <p>Grandparent</p>
            <Parent />
        </GiftWrapper.Provider>
    </div>)
}

export default UseContext;